import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerDailyStatsEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.dailyStats.get),
			switchMap((action) => of(ConsumerActions.dailyStats.getApi(_.omit(action, "type"))))
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.dailyStats.getApi),
			switchMap((action) =>
				this.consumerService.dailyStats(action.startDate, action.endDate).pipe(
					map((stats) =>
						ConsumerActions.dailyStats.getSuccess({ stats, loading: false })
					),
					catchError((error) =>
						of(ConsumerActions.dailyStats.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService
	) {}
}
